import {useMemo} from 'react';

import {COSMOS_CHAINS} from 'chains/cosmos/cosmos.assets';
import {CosmosChainId} from 'chains/cosmos/cosmos.types';

export const useChain = (chainId: CosmosChainId) => {
  return useMemo(() => {
    return Object.values(COSMOS_CHAINS).find(
      chain => chain.chainId === chainId,
    )!;
  }, [chainId]);
};
